<div id="levelOne">
    <ng-select class="width-percent-100 p-0" name="Level1Approver" [(ngModel)]="approverDetails.user" [multiple]="false"
               [ngModelOptions]="{standalone: true}" (change)="emitdata()" placeholder="{{'SelectApprover' | localize}}"
               [ngClass]="{ 'red-border': !approverDetails.user && isRequired } | localize">
        <ng-option [value]="item" *ngFor="let item of ProjectTeam">
            <div class="d-flex">
                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1 w-35px h-35px">
                    <img src="{{ item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                         class="h-35px w-35px border border-light p-1 rounded" id="profimgsize">
                </div>

                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                    <div class="font-weight-bold " pTooltip="{{ item.fullName}}"
                         [tooltipDisabled]="!_projService.showTooltip(item.fullName,25)" tooltipPosition="bottom">
                        {{
                        item.fullName | slice:0:25
                        }}{{ item.fullName?.length > 25 ? '...' : ''}}
                        <!-- {{ item.name | titlecase }} {{ item.surname | titlecase }} -->
                    </div>
                    <div style="font-size: 0.8rem;" pTooltip="{{ item.emailAddress}}"
                         [tooltipDisabled]="!_projService.showTooltip(item.emailAddress,25)" tooltipPosition="bottom">
                        {{item.emailAddress | slice:0:25}}{{ item.emailAddress?.length > 25 ? '...' : ''}}
                    </div>
                </div>

            </div>

        </ng-option>
        <ng-template ng-label-tmp let-item="item">
            <span class="d-flex align-items-center">
                <img height="17" width="17" class="mr-1 w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                     [src]="item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg'" />
                {{item.name | localize}}
            </span>
        </ng-template>
    </ng-select>
    <div *ngIf="!approverDetails.user && isRequired" class="text-danger" id="error-message">
        <span>{{'Level'  +" "+ levelValue+ " " + 'approver is mandatory' | localize}}</span>
    </div>
</div>
<div class="mt-3 text-muted"> {{'ApprovalWindow' | localize}}<span class="required text-danger"></span> </div>
<div class="d-flex">
    <div class="w-100">
        <div class="">
            <input type="number" (keypress)="onlyNumberKey($event)" class="form-control" required name="apprWin1"
                   (input)="emitdata()" min="0" #apprWin1="ngModel" [(ngModel)]="approverDetails.WindowNum" placeholder="{{'Select Approval' | localize}}"
                   [ngClass]="{ 'red-border': !approverDetails.WindowNum && isRequired } | localize">
        </div>
        <div id="error-message" class="text-danger line-height-md" *ngIf="!approverDetails.WindowNum && isRequired">
            {{'ApprovalWindowismandatory' | localize}}
        </div>
    </div>
    <label class="pr-4 pl-4 pt-2">{{'in'|localize}}</label>

    <div class="w-100" id="window">
        <ng-select [items]="WindowEnum" bindValue="id" bindLabel="name" [(ngModel)]="approverDetails.WindowEnum"
                   placeholder="{{'SelectWindowType' | localize}}" (change)="emitdata()"
                   [ngClass]="{ 'red-border': !approverDetails.WindowEnum && isRequired } | localize">
            <ng-template ng-option-tmp let-item="item">
                {{item.name | localize}}
            </ng-template>
        </ng-select>
        <div id="error-message" class="text-danger " *ngIf="!approverDetails.WindowEnum && isRequired">{{'WindowTypeismandatory' | localize}}</div>
    </div>
</div>
<div *ngIf="false" class="text-danger">
    <span><span>{{'ApproversWindowisrequired' | localize}}</span></span>
</div>
<div *ngIf="approverDetails.user != null" class="border p-2 mt-5 rounded">

    <div class="row">
        <div class="col-2 d-flex justify-content-center align-items-center rounded w-35px h-35px">
            <img src="{{ approverDetails.user.profileImage ? approverDetails.user.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                 class="w-35px h-35px img-fluid rounded border border-light p-1" id="profimgsize">
        </div>
        <div class=" col-9 d-flex align-items-start justify-content-center flex-column text-dark-75">
            <div class="font-weight-bold ">
                <span class="text-client-color" pTooltip="{{ approverDetails.user.fullName  }}"
                      [tooltipDisabled]="!_projService.showTooltip(approverDetails.user.fullName,25)"
                      tooltipPosition="bottom">
                    {{ approverDetails.user.fullName | slice:0:25}}{{
                    approverDetails.user.fullName?.length > 25 ? '...' : ''
                    }}
                </span>
            </div>
            <div style="font-size: 0.8rem;" pTooltip="{{ approverDetails.user.emailAddress  }}"
                 [tooltipDisabled]="!_projService.showTooltip(approverDetails.user.emailAddress,25)"
                 tooltipPosition="bottom">
                {{ approverDetails.user.emailAddress | slice:0:25}}{{
                approverDetails.user.emailAddress?.length > 25 ? '...' : ''
                }}
            </div>
        </div>
        <div class="col-1 px-0 py-2 cursor-pointer" (click)="emitDelete()" *ngIf="levelValue">
            <img class="cursor-pointer" src="assets/common/images/projects/Delete_Icon.svg" width="15" />
            <!-- <i class="la la-trash text-danger icon-md" style="width: 15px;"></i> -->
        </div>
    </div>
</div>
